import { render, staticRenderFns } from "./Reife.vue?vue&type=template&id=3dd87d06"
import script from "./Reife.vue?vue&type=script&lang=js"
export * from "./Reife.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports